import { render, staticRenderFns } from "./InventoryInfo.vue?vue&type=template&id=9c08b12a&scoped=true&"
import script from "./InventoryInfo.vue?vue&type=script&lang=js&"
export * from "./InventoryInfo.vue?vue&type=script&lang=js&"
import style0 from "./InventoryInfo.vue?vue&type=style&index=0&id=9c08b12a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c08b12a",
  null
  
)

export default component.exports